module.exports = __webpack_public_path__ + "static/img/landing-page-mid.3b46ff2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/sachassou/landing-page-mid.jpg
// module id = 1t8F
// module chunks = 1